/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

(function (window) {
  var readyList = []
  var readyFired = false
  var readyEventHandlersInstalled = false

  function ready () {
    if (!readyFired) {
      readyFired = true
      for (var i = 0; i < readyList.length; i++) {
        readyList[i].fn.call(window, readyList[i].ctx)
      }
      readyList = []
    }
  }

  function readyStateChange () {
    if (document.readyState === 'complete') {
      ready()
    }
  }

  var docReady = function (callback, context) {
    if (typeof callback !== 'function') {
      throw new TypeError('callback for docReady(fn) must be a function')
    }
    if (readyFired) {
      setTimeout(function () {callback(context)}, 1)
      return
    } else {
      // add the function and context to the list
      readyList.push({fn: callback, ctx: context})
    }
    if (document.readyState === 'complete' || (!document.attachEvent && document.readyState === 'interactive')) {
      setTimeout(ready, 1)
    } else if (!readyEventHandlersInstalled) {
      if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', ready, false)
        window.addEventListener('load', ready, false)
      } else {
        // must be IE
        document.attachEvent('onreadystatechange', readyStateChange)
        window.attachEvent('onload', ready)
      }
      readyEventHandlersInstalled = true
    }
  }

  var schoolwiki = window.schoolwiki = window.schoolwiki || {}

  schoolwiki.xd = function () {
    var interval_id,
      last_hash,
      cache_bust = 1,
      attached_callback

    return {
      postMessage: function (message, target_url, target) {
        if (!target_url) {
          return
        }
        target = target || parent  // default to parent
        if (window['postMessage']) {
          // the browser supports window.postMessage, so call it with a targetOrigin
          // set appropriately, based on the target_url parameter.
          target['postMessage'](message, target_url.replace(/([^:]+:\/\/[^\/]+).*/, '$1'))
        } else if (target_url) {
          // the browser does not support window.postMessage, so set the location
          // of the target to target_url#message. A bit ugly, but it works! A cache
          // bust parameter is added to ensure that repeat messages trigger the callback.
          target.location = target_url.replace(/#.*$/, '') + '#' + (+new Date) + (cache_bust++) + '&' + message
        }
      },
      receiveMessage: function (callback, source_origin) {
        // browser supports window.postMessage
        if (window['postMessage']) {
          // bind the callback to the actual event associated with window.postMessage
          if (callback) {
            attached_callback = function (e) {
              if ((typeof source_origin === 'string' && e.origin !== source_origin)
                || (Object.prototype.toString.call(source_origin) === '[object Function]' && source_origin(e.origin) === !1)) {
                return !1
              }
              callback(e)
            }
          }
          if (window['addEventListener']) {
            window[callback ? 'addEventListener' : 'removeEventListener']('message', attached_callback, !1)
          } else {
            window[callback ? 'attachEvent' : 'detachEvent']('onmessage', attached_callback)
          }
        } else {
          interval_id && clearInterval(interval_id)
          interval_id = null

          if (callback) {
            interval_id = setInterval(function () {
              var hash = document.location.hash,
                re = /^#?\d+&/
              if (hash !== last_hash && re.test(hash)) {
                last_hash = hash
                callback({data: hash.replace(re, '')})
              }
            }, 100)
          }
        }
      }
    }
  }()

  schoolwiki.config = schoolwiki.config || {}
  schoolwiki.iframe = schoolwiki.iframe || null
  schoolwiki.baseUrl = 'https://' + (window.__schoolwiki_domain || '79b0465beacd4.sadev.io')

  schoolwiki.init = function (config) {
    // Set config
    if (config && typeof config === 'object') {
      schoolwiki.config = config
    }

    // Render when loaded
    if (!('disabled' in schoolwiki.config && schoolwiki.config.disabled)) {
      docReady(schoolwiki.render)
    }

    // Listen for messages
    schoolwiki.xd.receiveMessage(function (message) {
      if (message.data && message.data.length) {
        if (message.data.indexOf('dimensions:') === 0) {
          var dimensions = message.data.substring(11).split(',')
          schoolwiki.iframe.style.width = dimensions[0]
          schoolwiki.iframe.style.height = dimensions[1]
        }
      }
    }, schoolwiki.baseUrl)
  }

  var cmd = function (msg) {
    schoolwiki.xd.postMessage(msg, schoolwiki.iframe.src, schoolwiki.iframe.contentWindow)
  }

  schoolwiki.render = function () {
    // Convenience
    var con = schoolwiki.config

    // Determine URL
    var src = schoolwiki.baseUrl + '/widget/search?config=' + encodeURIComponent(JSON.stringify(con)) + '#' + encodeURIComponent(document.location.href)

    // Check if already loaded
    if (schoolwiki.iframe) {
      schoolwiki.iframe.src = src
      if ('position' in con && con.position === 'left') {
        schoolwiki.iframe.style.left = '0'
        schoolwiki.iframe.style.right = 'auto'
      } else {
        schoolwiki.iframe.style.left = 'auto'
        schoolwiki.iframe.style.right = '0'
      }
      return
    }

    // Add button
    schoolwiki.iframe = document.createElement('iframe')
    schoolwiki.iframe.setAttribute('allowtransparency', 'true')
    schoolwiki.iframe.setAttribute('frameborder', '0')
    schoolwiki.iframe.setAttribute('scrolling', 'no')
    schoolwiki.iframe.setAttribute('src', src)
    schoolwiki.iframe.setAttribute('class', 'schoolwiki-widget')
    var styles = 'background:transparent!important;position:fixed;max-width:100vw;margin:0!important;top:auto;z-index:88888;bottom:0;border:0;text-indent:0!important;width:0;height:0;'
    if ('position' in con && con.position === 'left') {
      styles += 'left:0;'
    } else {
      styles += 'right:0;'
    }
    schoolwiki.iframe.setAttribute('style', styles)
    document.body.appendChild(schoolwiki.iframe)

    // Mark loaded
    schoolwiki.loaded = true
  }

  schoolwiki.show = function () {
    if (!schoolwiki.iframe) {
      throw '[schoolwiki] Widget not yet rendered'
    }
    cmd('show')
  }

  schoolwiki.hide = function () {
    if (!schoolwiki.iframe) {
      throw '[schoolwiki] Widget not yet rendered'
    }
    cmd('hide')
  }

  schoolwiki.toggle = function () {
    if (!schoolwiki.iframe) {
      throw '[schoolwiki] Widget not yet rendered'
    }
    cmd('toggle')
  }

  schoolwiki.search = function (query) {
    if (!schoolwiki.iframe) {
      throw '[schoolwiki] Widget not yet rendered'
    }
    if (!query) {
      throw '[schoolwiki] No search query specified'
    }
    cmd('search:' + query)
  }

  schoolwiki.setConfig = function (config) {
    if (!config || typeof config !== 'object') {
      throw '[schoolwiki] No config object specified'
    }

    schoolwiki.config = config
    schoolwiki.render()
  }

  schoolwiki.destroy = function () {
    if (!schoolwiki.iframe) {
      throw '[schoolwiki] Widget not yet rendered'
    }

    schoolwiki.iframe.parentElement.removeChild(schoolwiki.iframe)
  }

})
(window)

